//	src/firebase.js

import { initializeApp } from 'firebase/app';
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithPopup, 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword, 
  updateProfile,
  sendPasswordResetEmail,  
  signOut
} from 'firebase/auth';
// 1. Import Firestore database methods
import { getFirestore, doc, setDoc } from 'firebase/firestore'; 

const firebaseConfig = {
  apiKey: "AIzaSyC9HOOsT5ynGk4I0PlBnhMUFaxdMr0GC3A",
  authDomain: "gangasolvo.firebaseapp.com",
  databaseURL: "https://gangasolvo-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "gangasolvo",
  storageBucket: "gangasolvo.appspot.com",
  messagingSenderId: "16985429162",
  appId: "1:16985429162:web:3d77dafc70cbda944b6cd3",
  measurementId: "G-B0616MY411"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
// 2. Initialize Firestore database
export const db = getFirestore(app); 

export const logInWithGoogle = () => signInWithPopup(auth, googleProvider);
export const logOut = () => signOut(auth);
export const logInWithEmail = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

// 3. Updated to accept and store the phone number
export const signUpWithEmail = async (name, email, password, phone) => {
  // A. Create the user credentials inside Firebase Auth
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;

  // B. Attach their name to their display profile
  await updateProfile(user, {
    displayName: name
  });

  // C. Create a document in Firestore under 'users/USER_UID' to store the phone number
  await setDoc(doc(db, 'users', user.uid), {
    uid: user.uid,
    name: name,
    email: email,
    phone: phone, // <-- This saves it securely to your database
    createdAt: new Date().toISOString()
  });

  return userCredential;
};

export const resetPassword = (email) => {
  return sendPasswordResetEmail(auth, email);
};